import ButtonEvent from "@/ScannerEvents/ButtonEvent";
import StockEvent from "@/ScannerEvents/StockEvent";
import MutationEvent from "@/ScannerEvents/MutationEvent";

export default class ScannerEventDetector {
    /** @type {ScannerEvent[]} **/
    registeredEvents = [ButtonEvent, StockEvent, MutationEvent];

    constructor(onScanEvent) {
        if (typeof onScanEvent !== "function") {
            throw new Error("onScanEvent requires a callback function");
        }

        this.onScanEvent = onScanEvent;
    }

    handleScannerInput(scannerInput) {
        if (typeof scannerInput === "string") {
            scannerInput = JSON.parse(scannerInput);
        }

        if (!("t" in scannerInput) || !("d" in scannerInput)) {
            // eslint-disable-next-line no-console
            console.warn("[ScannerEventDetector] Missing type or data in received scanner JSON data");

            return;
        }

        const eventType = scannerInput.t;
        const eventData = scannerInput.d;

        for (const eventHandler of this.registeredEvents) {
            if (! eventHandler.MatchesType(eventType)) {
                continue;
            }

            const parsedEvent = eventHandler.ParseData(eventData);

            this.onScanEvent(parsedEvent);

            return;
        }

        console.warn(`[ScannerEventDetector] Received unknown scanner event: ${eventType}`);
    }
}
